



















































































































import { Component, Watch , Vue, Prop } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import { AudienceSearchFilter } from '../models/AudienceSearchFilter';
import TagSelector from '@/components/TagSelector.vue';
import PropertySelector from '@/components/PropertySelector.vue';
import { Getter, Action } from 'vuex-class';

interface SearchPanelItem {
    field: {
        name: string,
        value: string,
        typeOfInput: string
    };
    operator: string;
    operatorList: object[];
    value: string;
    date1: string;
    date2: string;
    tag: string ;
    tagsSelected: Array<{ text: string }>;
    tagList: Array<{ text: string }>;
    property: string;
    propertiesSelected: any[];
    propertyList: object[];
}

@Component({
    components: {
        TagSelector,
        PropertySelector,
        Datepicker
    },
})
export default class AudienceSearchPanel extends Vue {

    @Prop(Number) public clientId!: number;

    @Prop(Boolean) public isSelectable!: boolean;

    public SearchFilterResults: AudienceSearchFilter[] = [new AudienceSearchFilter('isActive', 'equals', true)];

    @Getter('searchPanelCache', { namespace: 'manageAudience' })
    private searchPanelCache!: any;

    @Action('setSearchPanelCache', {  namespace: 'manageAudience'  })
    private setSearchPanelCache!: any;

    @Getter('SearchPanelActiveFlagCache', { namespace: 'manageAudience' })
    private SearchPanelActiveFlagCache!: boolean;

    @Action('setSearchPanelActiveFlagCache', {  namespace: 'manageAudience'  })
    private setSearchPanelActiveFlagCache!: any;

    private checkboxDeactivatedAudiences: boolean = false;
    private isDirty: boolean = false;
    private searchRowCount: number = 1;
    private availableFields: object[] = [
        {
            name: 'Audience Name',
            value: 'Name',
            typeOfInput: 'regular',
        },
        {
            name: 'Description',
            value: 'Description',
            typeOfInput: 'regular',
        },
        {
            name: 'Tags',
            value: 'searchbytags',
            typeOfInput: 'tags',
        },
        {
            name: 'Created By',
            value: 'AudienceCreatedByUserID',
            typeOfInput: 'regular',
        },
        {
            name: 'Created On',
            value: 'audienceCreatedOn',
            typeOfInput: 'date',
        },
        {
            name: 'Modified By',
            value: 'audienceUpdatedByUserID',
            typeOfInput: 'regular',
        },
        {
            name: 'Modified On',
            value: 'audienceUpdatedOn',
            typeOfInput: 'date',
        },
        {
            name: 'Property(s)',
            value: 'searchbypropertycodes',
            typeOfInput: 'properties',
        },
    ];

    private operatorList: Array<{ name: string, value: string }> = [
        { name: 'Equals', value: 'equals' },
        { name: 'Contains', value: 'contains' },
        { name: 'Begins With', value: 'startwith' },
        { name: 'Ends With', value: 'endwith' },
        { name: 'Between', value: 'between' }
    ];

    private tagList: Array<{ text: string }> = [];

    private propertyList: object[] = [];

    private defaultContent: object = {
        field: {
            name: 'Audience Name',
            value: 'Name',
            typeOfInput: 'regular'
        },
        operator: 'equals',
        operatorList: this.operatorList,
        value: '',
        date1: new Date().toLocaleDateString(),
        date2: new Date().toLocaleDateString(),
        tag: '',
        tagsSelected: [],
        tagList: this.tagList,
        property: '',
        propertiesSelected: [],
        propertyList: this.propertyList
    };

    private searchRows: SearchPanelItem[] = [
        {
            field: {
                name: 'Audience Name',
                value: 'Name',
                typeOfInput: 'regular'
            },
            operator: 'equals',
            operatorList: this.operatorList,
            value: '',
            date1: '',
            date2: '',
            tag: '',
            tagsSelected: [],
            tagList: this.tagList,
            property: '',
            propertiesSelected: [],
            propertyList: this.propertyList
        }
    ];

    @Watch('searchRows', { deep: true })
    public onSearchRowsUpdated(value: AudienceSearchFilter[]) {
        this.handleSearchChange();
    }
    // cache search
    public cacheSearchPanel() {
        const currentRows: any = JSON.parse(JSON.stringify(this.searchRows));
        this.setSearchPanelCache({ data: currentRows });
        this.setSearchPanelActiveFlagCache({ showInactive: this.checkboxDeactivatedAudiences });
    }

    private updateIsDirty(isDirty: boolean): void {
        this.isDirty = isDirty;
    }

    private handleSearchChange(): void {
        const results: AudienceSearchFilter[] = [];
        // Inactive audience does not rely on isDirty
        if (!this.checkboxDeactivatedAudiences) {
            results.push(new AudienceSearchFilter('isActive', 'equals', true));
        }
        // if form clean do now update search filters
        // sometimes clean but (this.searchRows[0].value.length) has value.
        // (enter value in input then click search or toggle, isDirty does not get updated)
        if (this.isDirty || this.searchRows.length > 1 ||
            (this.searchRows[0].value.length > 0 ||
            this.searchRows[0].propertiesSelected.length > 0 ||
            this.searchRows[0].tagsSelected.length > 0 ||
            this.searchRows[0].field.typeOfInput === 'date'
            )
        ) {
            if (!this.checkboxDeactivatedAudiences) {
                results.push(new AudienceSearchFilter('isActive', 'equals', true));
            }

            for (const row of this.searchRows) {
                if (row.operator === 'between') {
                    // Create 2 criteria  (AudienceDate > date1 && Audiencedate < data2)
                    results.push(new AudienceSearchFilter(row.field.value, 'greaterthan', row.date1));
                    results.push(new AudienceSearchFilter(row.field.value, 'lessthan', row.date2));
                } else if (row.field.typeOfInput === 'date') {
                    // if searching by date then create criteria using date1
                    results.push(new AudienceSearchFilter(
                        row.field.value,
                        row.operator,
                        row.date1));
                } else if (row.field.typeOfInput === 'tags') {
                    // if tags create criteria for each tag
                    if (row.operator === 'equals') {
                        const allTags: any = JSON.parse(JSON.stringify(row.tagsSelected));
                        allTags.sort((a, b) => {
                            if (a.text < b.text) { return -1; }
                            if (a.text > b.text) { return 1; }
                            return 0;
                        });
                        let tags: string = '';
                        for (const tag of allTags) {
                            tags += tags.length === 0 ? tag.text : ',' + tag.text;
                        }
                        // Allow for empty searches
                        results.push(new AudienceSearchFilter(
                            row.field.value,
                            row.operator,
                            tags)
                        );
                    } else {
                        for (const tag of row.tagsSelected) {
                            results.push(new AudienceSearchFilter(
                                row.field.value,
                                row.operator,
                                tag.text)
                            );
                        }
                    }

                    if (row.tagsSelected.length === 0) {
                        results.push(new AudienceSearchFilter(row.field.value, row.operator, ''));
                    }
                } else if (row.field.typeOfInput === 'properties') {
                    if (row.operator === 'equals') {
                        const AllPropertiesSelected: any = JSON.parse(JSON.stringify(row.propertiesSelected));
                        AllPropertiesSelected.sort((a, b) => {
                            if (a.code < b.code) { return -1; }
                            if (a.code > b.code) { return 1; }
                            return 0;
                        });
                        let properties: string = '';
                        for (const prop of AllPropertiesSelected) {
                            properties += properties.length === 0 ? prop.code : ',' + prop.code;
                        }
                        // Allow for empty searches
                        results.push(new AudienceSearchFilter(
                            row.field.value,
                            row.operator, properties)
                        );
                    } else {
                        for (const pro of row.propertiesSelected) {
                            results.push(new AudienceSearchFilter(
                                row.field.value,
                                row.operator, pro.code)
                            );
                        }
                    }
                } else {
                    results.push(new AudienceSearchFilter(
                        row.field.value,
                        row.operator,
                        row.value));
                }
            }
        }
        this.SearchFilterResults = results;
    }

    private executeSearch(): void {
        this.$emit('onSearch');
    }

    private resetSearchFields(): void {
        this.checkboxDeactivatedAudiences = false;
        this.updateIsDirty(false);
        this.searchRowCount = 1;

        const defaultData = JSON.parse(JSON.stringify(this.defaultContent));
        this.searchRows = [defaultData];

        this.filterAvailableConditions(0);

        this.SearchFilterResults = [new AudienceSearchFilter('isActive', 'equals', true)];
        this.$emit('onSearch');
    }

    private addSearchRow(): void {
        if (this.searchRowCount < 5) {
            const dummyData = JSON.parse(JSON.stringify(this.defaultContent));
            this.searchRows.push(dummyData);
            this.searchRowCount++;
        }
    }

    private removeRow(idx: number): void {
        this.searchRows.splice(idx, 1);
        this.searchRowCount--;
    }

    private showCalendar(ref: string): void {
        const datepicker: any = this.$refs[ref][0];
        datepicker.$el.querySelector('input').click(); // Show calendar
        datepicker.$el.querySelector('input').focus(); // Set focus so blur will remove the calendar
    }

    private filterAvailableConditions(idx: number): void {
        const firstSearchInputType = this.searchRows[idx].field.typeOfInput;
        const currentRow = this.searchRows[idx];
        const globalAvailableConditions = JSON.parse(JSON.stringify(this.operatorList));

        if (firstSearchInputType === 'date') {
            currentRow.operatorList = globalAvailableConditions.filter((x) => {
                if ((x as any).value === 'equals' || (x as any).value === 'between') {
                    return x;
                }
            });

        } else if (firstSearchInputType === 'tags' || firstSearchInputType === 'properties') {
            currentRow.operatorList = globalAvailableConditions.filter((x) => {
                if ((x as any).value === 'equals' || (x as any).value === 'contains') {
                    return x;
                }
            });
        } else {
            currentRow.operatorList = globalAvailableConditions.filter((x) => {
                if ((x as any).value !== 'between') {
                    return x;
                }
            });
        }

        currentRow.operator = 'equals';
        currentRow.date1 = new Date().toLocaleDateString();
        currentRow.date2 = new Date().toLocaleDateString();
        currentRow.value = '';
        currentRow.tagsSelected = [];
        currentRow.propertiesSelected = [];
    }

    private mounted() {
        this.filterAvailableConditions(0);
        if (this.searchPanelCache != null) {
            this.searchRows = this.searchPanelCache;
            this.checkboxDeactivatedAudiences = this.SearchPanelActiveFlagCache;
            this.handleSearchChange();
        }
    }

    private clearTags(index: number) {
        this.searchRows[index].tag = '';
    }
}
